import React from "react";
import { Helmet } from "react-helmet";
import { resolvePublicSeo } from "./publicPageSeo";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://www.7cantos.com";
const STAGING_ROBOTS = "noindex, nofollow";

interface PublicPageHelmetProps {
  pathname: string;
  search?: string;
}

function queryFromSearch(search: string): Record<string, string> {
  return Object.fromEntries(new URLSearchParams(search));
}

export default function PublicPageHelmet({ pathname, search = "" }: PublicPageHelmetProps) {
  const seo = resolvePublicSeo(pathname, queryFromSearch(search), SITE_URL);
  if (!seo) {
    return null;
  }

  const robots = process.env.REACT_APP_ENV === "staging" ? STAGING_ROBOTS : seo.robots;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.canonicalUrl} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <link rel="canonical" href={seo.canonicalUrl} />
      <meta name="robots" content={robots} />
    </Helmet>
  );
}
